module.exports = __webpack_public_path__ + "images/emoji/hearts.af2ad7e273aa7fee5430.png";